"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { getCoursePreviewFetcherToken } from "@/lib/api";
import { readStoredCoursePreviewToken } from "@/lib/course-preview";
import { markLessonComplete, fetchCourseProgress } from "./api";

export function useMarkComplete() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      courseId,
      lessonId,
      token,
    }: {
      courseId: string;
      lessonId: string;
      token: string;
    }) => markLessonComplete(courseId, lessonId, token),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.lessons.detail(variables.lessonId),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.progress.course(variables.courseId),
      });
      void queryClient.invalidateQueries({ queryKey: queryKeys.me.library });
      void queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.overview });
    },
  });
}

export function useCourseProgress(courseId: string, token?: string) {
  const previewKey =
    typeof window !== "undefined"
      ? (getCoursePreviewFetcherToken() ?? readStoredCoursePreviewToken() ?? "")
      : "";

  return useQuery({
    queryKey: queryKeys.progress.course(courseId, previewKey),
    queryFn: () => fetchCourseProgress(courseId, token),
    enabled: !!courseId && (!!token || !!previewKey),
  });
}
